import {
    MdLocalShipping,
    MdCheckCircle,
    MdOutlineAccessTime,
} from "react-icons/md";

function Timeline({ history }) {
    return (
        <div className="timeline">
            {history.map((item, index) => (
                <div key={index} className="timeline-item">
                    <div className="timeline-icon">
                        {item.status_code === "DL" ? (
                            <MdCheckCircle color="green" />
                        ) : item.status_code === "OFD" ? (
                            <MdLocalShipping color="#f59e0b" />
                        ) : (
                            <MdOutlineAccessTime color="#6b7280" />
                        )}
                    </div>
                    <div className="timeline-content">
                        <p className="message">{item.message}</p>
                        <p className="time">{item.event_time}</p>
                        <p className="location">{item.location}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Timeline;
